import { useEffect } from 'react';
import { Check } from 'lucide-react';
import { Button, Typography } from '@/components/common';
import { ModalHeader } from '@/components/dashboard';
import useModal from '@/hooks/useModal';
import { useMediaQuery } from 'react-responsive';

interface Props {
	isOpen?: boolean;
	showButton?: boolean;
	onClickCancel?: () => void;
	onClickContinue: (callback: any) => void;
}

export const ModalResolved: React.FC<Props> = ({
	isOpen,
	onClickCancel,
	onClickContinue,
	showButton = true,
}) => {
	const {
		Modal: ModalResolved,
		show: showModalResolved,
		hide: hideModalResolved,
	} = useModal();

	useEffect(() => {
		if (isOpen) {
			showModalResolved();
		}
	}, [isOpen]);

	const handleClickCancel = () => {
		if (onClickCancel) {
			onClickCancel();
		}
		hideModalResolved();
	};

	const isDesktopOrLaptop = useMediaQuery({
		query: '(min-width: 1024px)',
	});

	return (
		<>
			{showButton && (
				<Button
					decoration="secondary"
					size={isDesktopOrLaptop ? 'medium' : 'small'}
					onClick={() => showModalResolved()}
					className="space-x-2"
				>
					<span>Mark as Resolved</span>
					<Check size={16} color="#636a73" />
				</Button>
			)}
			<ModalResolved
				withXButton
				onClose={handleClickCancel}
				classNameCardContainer="max-w-xl"
				title={<ModalHeader title="Inquiry Resolved" />}
			>
				<div className="mt-2 px-6 md:px-8">
					<Typography type="regular-16" className="text-center">
						{`By marking this inquiry as resolved, the conversation will be
						closed, and the client will no longer be able to respond in this
						thread.`}
					</Typography>
					<Typography type="regular-16" className="text-center mt-8">
						{`Please confirm if you'd like to close the conversation.`}
					</Typography>
					<div className="flex flex-col md:flex-row gap-4 justify-center mt-8">
						<Button
							size="fit"
							decoration="secondary"
							onClick={handleClickCancel}
							className="!py-4 w-full md:w-auto order-2 md:order-1 "
						>
							Cancel
						</Button>
						<Button
							size="fit"
							decoration="primary"
							onClick={() => onClickContinue(hideModalResolved)}
							className="!py-4 w-full md:w-auto order-1 md:order-2"
						>
							Yes, Mark as Resolved
						</Button>
					</div>
				</div>
			</ModalResolved>
		</>
	);
};
